<ng-template #summary let-elements="elements">
  <div class="summary user" *ngIf="elements.length > 0">
    <!-- <ng-oct-timeline [timelineElements]="elements"></ng-oct-timeline> -->
    <mat-list>
      <mat-list-item *ngFor="let timelineElement of elements" [ngSwitch]="timelineElement.status">
        <mat-icon class="icon safe" *ngSwitchCase="'created'" svgIcon="add_circle_outline"></mat-icon>
        <mat-icon class="icon red" *ngSwitchCase="'deviation'" svgIcon="error"></mat-icon>
        <mat-icon class="icon safe" *ngSwitchCase="'remediated'" svgIcon="construction"></mat-icon>
        <span class="date">{{ timelineElement.date }} </span>
      </mat-list-item>
    </mat-list>
  </div>
</ng-template>

<div *ngIf="groupBaselineDeviations !== null" class="box">
  <div *ngFor="let group of groupBaselineDeviations | keyvalue" class="group-container">
    <span class="group icon">
      <mat-icon svgIcon="groups"></mat-icon><b>Group: {{ group.key }} </b>
    </span>
    <div style="margin: 3mm 0" *ngFor="let baseline of group.value | keyvalue">
      <ng-container *ngIf="baseline.value === null; else showUsers" class="group-content">
        <span class="icon">
          <mat-icon class="safe" svgIcon="done"></mat-icon>
          {{ baseline.key }}
        </span>
      </ng-container>

      <ng-template #showUsers>
        <span class="icon">
          <mat-icon class="critical" svgIcon="info-square"></mat-icon>
          {{ baseline.key }}
        </span>
        <div *ngFor="let user of baseline.value | keyvalue">
          <span class="user icon">
            <mat-icon [ngClass]="user.value.status === 'deviating' ? 'critical' : 'safe'" svgIcon="person"></mat-icon>
            {{ user.key }}
            <span style="font-style: italic">(Group: {{ group.key }}, Baseline: {{ baseline.key }})</span>
          </span>
          <ng-container
            [ngTemplateOutlet]="summary"
            [ngTemplateOutletContext]="{ elements: user.value.timelineElements }"
          ></ng-container>
        </div>
      </ng-template>
    </div>
  </div>
</div>
